<div class="back_element mx-3">
  <i class="fa-solid fa-chevron-left"></i>
  <a  (click)="goBack();" class="link-secondary m-2 fw-bolder">{{this.text}}</a>
</div>
